import axios, { AxiosResponse } from "axios";
import { ChangeStepDTO } from "../../models/dtos/content/leitner/ChangeStepDTO";
import { WordCardsDTO } from "../../models/dtos/content/leitner/WordCardsDTO";
import { ReadingWordsQueryString } from "../../models/query-strings/content/leitner/ReadingWordsQueryString";
import BaseService from "../base/BaseService";

export default class LearningBoxCardService extends BaseService {
    create(changeStepDTO: ChangeStepDTO): Promise<any> {
        return axios.post(`/LearningBoxCard`, changeStepDTO)
            .then(function (response: AxiosResponse<any, any>) {
                return response.data;
            });
    }

    getPaged(readingWordsQueryString: ReadingWordsQueryString): Promise<WordCardsDTO[]> {
        return axios.get(`/LearningBoxCard`, { params: readingWordsQueryString })
            .then(function (response: AxiosResponse<WordCardsDTO[], any>) {
                return response.data;
            });
    }

    getLevelsInformationById(boxId: string): Promise<IFlashCardLevelsDTO[]> {
        return axios.get(`/LearningBoxCard/Levels/${boxId}`)
            .then(function (response: AxiosResponse<IFlashCardLevelsDTO[], any>) {
                return response.data;
            });
    }

    getTodayFlashCardsById(boxId: string): Promise<WordCardsDTO[]> {
        return axios.get(`/LearningBoxCard/Today/${boxId}`)
            .then(function (response: AxiosResponse<WordCardsDTO[], any>) {
                return response.data;
            });
    }
}
interface IFlashCardLevelsDTO {
    level: number
    flashCardId: string
}